
export const LIST_FIELDS = {
  NAME: 'name',
  PHONE: 'phone_number',
  EMAIL: 'email',
  ZALO: 'zalo',
  ADDRESS: 'address',
  MESSAGE: 'message',
  BIRTHDAY: 'birthday',
  JOB: 'job',
  REASON_REGISTER: 'reason_register',
  SOURCE_FROM: 'source_from',
  FACEBOOK: 'facebook',
  COOPERATION: 'cooperation',
}

export const CONFIG_FIELDS = {
  [LIST_FIELDS.NAME]: {
    name: 'name',
    key: 'name',
    type: 'input',
    label: "common_name",
    placeholder: "common_enterName",
    message: "common_pleaseEnterName"
  },
  [LIST_FIELDS.PHONE]: {
    name: 'phone_number',
    key: 'phone',
    type: 'input',
    typeInput: "phone",
    label: "common_phoneNumber",
    placeholder: "common_enterPhoneNumber",
    message: "common_pleaseEnterPhoneNumber"
  },
  [LIST_FIELDS.ZALO]: {
    name: 'zalo',
    key: 'zalo',
    type: 'input',
    typeInput: "phone",
    label: "common_phoneZalo",
    placeholder: "common_enterPhoneZalo",
    message: "common_pleaseEnterPhoneZalo"
  },
  [LIST_FIELDS.EMAIL]: {
    name: 'email',
    key: 'email',
    type: 'input',
    typeInput: "email",
    label: "common_email",
    placeholder: "common_enterEmail",
    message: "common_pleaseEnterEmail"
  },
  [LIST_FIELDS.ADDRESS]: {
    name: 'address',
    key: 'address',
    type: 'textarea',
    label: "common_address",
    placeholder: "common_enterAddress",
    message: "common_pleaseEnterAddress"
  },
  [LIST_FIELDS.MESSAGE]: {
    name: 'message',
    key: 'message',
    type: 'textarea',
    label: "common_message",
    placeholder: "common_enterMessage",
    message: "common_pleaseEnterMessage"
  },
  [LIST_FIELDS.BIRTHDAY]: {
    name: 'birthday',
    key: 'birthday',
    type: 'input',
    label: "landingpageCTVRegister_birthday",
    placeholder: "landingpageCTVRegister_enterBirthday",
    message: "landingpageCTVRegister_pleaseEnterBirthday"
  },
  [LIST_FIELDS.JOB]: {
    name: 'job',
    key: 'job',
    type: 'input',
    label: "landingpageCTVRegister_career",
    placeholder: "landingpageCTVRegister_enterCareer",
    message: "landingpageCTVRegister_pleaseEnterInfo"
  },
  [LIST_FIELDS.REASON_REGISTER]: {
    name: 'reason_register',
    key: 'reason_register',
    type: 'input',
    label: "landingpageCTVRegister_reasonRegister",
    placeholder: "landingpageCTVRegister_enterReasonRegister",
    message: "landingpageCTVRegister_pleaseEnterInfo"
  },
  [LIST_FIELDS.SOURCE_FROM]: {
    name: 'source_from',
    key: 'source_from',
    type: 'textarea',
    label: "landingpageCTVRegister_sourceFrom",
    placeholder: "landingpageCTVRegister_entersourceFrom",
    message: "landingpageCTVRegister_pleaseEnterInfo"
  },
  [LIST_FIELDS.FACEBOOK]: {
    name: 'facebook',
    key: 'facebook',
    type: 'textarea',
    label: "landingpageCTVRegister_yourFacebook",
    placeholder: "landingpageCTVRegister_enterYourFacebook",
    message: "landingpageCTVRegister_pleaseEnterInfo"
  },
  [LIST_FIELDS.COOPERATION]: {
    name: 'cooperation',
    key: 'cooperation',
    type: 'select',
    label: "landingpageCTVRegister_cooperation",
    placeholder: "landingpageCTVRegister_enterCooperation",
    message: "landingpageCTVRegister_pleaseEnterCooperation",
    options: [
      { value: "collaborators", label: "Cộng tác viên" },
      { value: "distributors", label: "Nhà phân phối" },
    ]
  },
}